<template>
  <div class="modal-item-nav-btns">
    <div v-if="unsavedChanges && prevNext.prev">
      <GekkoButton 
        @click="navigateTo(prevNext.prev, 'prev', true)" 
        :text="$gettext('Save and Previous')"
        icon="fa-solid fa-arrow-left"
        variant="link text-blue"
        :disabled="!prevNext.prev"
        class="p-0"
      />
    </div>
    <div v-else :class="{ 'nav-disabled': !prevNext.prev }">
      <GekkoButton 
        @click="navigateTo(prevNext.prev, 'prev')" 
        :text="$gettext('Previous')"
        icon="fa-solid fa-arrow-left"
        variant="link text-blue"
        :disabled="!prevNext.prev"
        class="p-0"
      />
    </div>
    <div class="nav-separator">|</div>
    <div v-if="unsavedChanges && prevNext.next">
      <GekkoButton 
        @click="navigateTo(prevNext.next, 'next', true)" 
        :text="$gettext('Save and Next')"
        icon="fa-solid fa-arrow-right"
        icon-right
        variant="link text-blue"
        :disabled="!prevNext.next"
        class="p-0"
      />
    </div>
    <div v-else :class="{ 'nav-disabled': !prevNext.next }">
      <GekkoButton 
        @click="navigateTo(prevNext.next, 'next')" 
        :text="$gettext('Next')"
        icon="fa-solid fa-arrow-right"
        icon-right
        variant="link text-blue"
        :disabled="!prevNext.next"
        class="p-0"
      />
    </div>
  </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'PrevNextNavButtons',
  components: {
    GekkoButton,
  },
  props: {
    itemId: {
      type: [String, Number],
      default: null
    },
    unsavedChanges: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      unsubscribe: null,
      prevNext: { prev: false, next: false },
      currentNext: false,
      useCurrentNext: false,
      navigating: null
    }
  },

  methods: {
    async checkPrevNext () {
      // calculate item position in store tempItemList to get prev & next
      // first time set it to initial item list

      if (this.tempItemList.length > 0) {
        let prev = false, next = false
        const itemPos = this.tempItemList.findIndex(item => item.id == this.itemId)
        if (itemPos > -1) { // this.itemId is in current list
          /**
           * 'next' is most recent item, so previous element on that current list,
           * should be already there unless it's first item (most recent)
           */
          next = (itemPos > 0) ? (itemPos - 1) : false
          this.prevNext.next = (next || next === 0) ? this.tempItemList[next].id : false
          /**
           * 'prev' is next item on item list, could not be there yet, so check for next page.
           *  if not last item on currentList, take next position as 'prev'
           */
          prev = (itemPos + 1)
          if (itemPos < (this.tempItemList.length - 1)) {
            this.prevNext.prev = (prev || prev === 0) ? this.tempItemList[prev].id : false
          } else {
            // if last item, check for next pages (if next page is avalable)
            await this.getMoreItems()
            this.prevNext.prev = (prev || prev === 0) ? this.tempItemList[prev]?.id : false
          }
        } else { // this.itemId not in current list
          this.getMoreItems(true)
        }
      } 
    }
  }
}
</script>

<style lang="scss">
  .modal-item-nav-btns {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: $colorBrand;
    font-size: 1rem;
    margin: 0 auto;
    .nav-separator { opacity: 0.5; }
      @media (min-width: '768px') {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>